import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../../global-config'
import { productSearchAlgoliaAccessorGetDiscountData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetDiscountData'
import { productSearchAlgoliaAccessorStockStatusIsAvailable } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorStockStatusIsAvailable'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'
import { ProductSearchResultItemProductLinkWithIcon } from '../ProductSearchResultItemProductLinkWithIcon'

import { ProductSearchResultItemPriceContainerDiscountBadge } from './ProductSearchResultItemPriceContainerDiscountBadge'
import { ProductSearchResultItemPriceContainerFormattedUnitPrice } from './ProductSearchResultItemPriceContainerFormattedUnitPrice'
import { ProductSearchResultItemPriceContainerListPrice } from './ProductSearchResultItemPriceContainerListPrice'
import { ProductSearchResultItemPriceContainerRetailPrice } from './ProductSearchResultItemPriceContainerRetailPrice'

export const ProductSearchResultItemPriceContainer: FC = () => {
  const { algoliaRecord } = useProductSearchResultItemContext()
  const { discountBoundaries, tenant } = useGlobalConfigContext()

  const { hasDiscount, showDiscount } =
    productSearchAlgoliaAccessorGetDiscountData(
      algoliaRecord,
      discountBoundaries,
      tenant,
    )

  const isAvailable =
    productSearchAlgoliaAccessorStockStatusIsAvailable(algoliaRecord)

  return isAvailable ? (
    <div className="flex flex-col gap-0.5">
      <ProductSearchResultItemProductLinkWithIcon />
      <div className="flex gap-1">
        <ProductSearchResultItemPriceContainerDiscountBadge />
        <ProductSearchResultItemPriceContainerRetailPrice
          hasDiscount={hasDiscount}
        />
      </div>

      <ProductSearchResultItemPriceContainerFormattedUnitPrice classNames="text-s" />
      <ProductSearchResultItemPriceContainerListPrice
        showDiscount={showDiscount}
      />
    </div>
  ) : null
}
